exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bII4Iijs8ZfZfMKfu1eMq{margin:0 0 20px 0}._1dNkTLMfZybFlukk2qPHjX{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"lessMargin": "bII4Iijs8ZfZfMKfu1eMq",
	"successMessage": "_1dNkTLMfZybFlukk2qPHjX"
};